/**
 * Links into Todoist. Web addresses rather than todoist:// schemes: in a
 * browser they open the web app, and on iPhone and Mac an installed Todoist
 * app claims them — so one link works everywhere, with no "app not installed"
 * dead end.
 *
 * There is no link that opens "add a task" already filed under a project or
 * section: Todoist's add-task schemes take only the text, date and priority.
 * So adding opens the project itself, where its own "Add task" sits under
 * each section.
 */

export const todoistTaskUrl = (id: string) => `https://app.todoist.com/app/task/${id}`;
export const todoistProjectUrl = (id: string) => `https://app.todoist.com/app/project/${id}`;
export const TODOIST_UPCOMING_URL = "https://app.todoist.com/app/upcoming";
/** Todoist's project list, where a new project is added. */
export const TODOIST_PROJECTS_URL = "https://app.todoist.com/app/projects";

export function openInTodoist(url: string): void {
  window.open(url, "_blank", "noopener,noreferrer");
}
